import { render, staticRenderFns } from "./m-menu-chip.vue?vue&type=template&id=d68576ca&scoped=true&"
import script from "./m-menu-chip.vue?vue&type=script&lang=js&"
export * from "./m-menu-chip.vue?vue&type=script&lang=js&"
import style0 from "./m-menu-chip.vue?vue&type=style&index=0&id=d68576ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68576ca",
  null
  
)

export default component.exports